import Siema from 'siema'

const quoteSlider = document.querySelectorAll('[data-testimonials]')

quoteSlider.forEach((slider) => {
    let siema = slider.querySelector('.slider')
    let prev = slider.querySelector('.prev')
    let next = slider.querySelector('.next')
    let slides = slider.querySelectorAll('.slider blockquote')
    let thumbnails = slider.querySelectorAll('[data-thumbnail]')

    // Siema config
    let instance = new Siema({
        selector: siema,
        duration: 400,
        easing: 'ease-out',
        startIndex: 0,
        perPage: 1,
        perPage: {
            800: 2,
        },
        draggable: true,
        loop: true,
        threshold: 20,
        onInit: active,
        onChange: active,
    })

    // Autoplay (optional)
    let autoplay = setInterval(() => instance.next(), 4000)

    // Navigation
    if (prev) {
        prev.addEventListener('click', function () {
            // console.log(this, 'clicked')
            instance.prev()
            clearInterval(autoplay)
        })
    }

    if (next) {
        next.addEventListener('click', function () {
            // console.log(this, 'clicked')
            instance.next()
            clearInterval(autoplay)
        })
    }

    // Thumbnail navigation (optional)
    if (thumbnails) {
        thumbnails.forEach((item, slide) => {
            item.addEventListener('click', function () {
                // console.log(this, 'clicked')
                instance.goTo(slide)
                clearInterval(autoplay)
                activeThumb(index)
            })
        })
    }

    // Add class to active slide
    function active() {
        slides.forEach((slide) => slide.classList.remove('--active'))
        slides[this.currentSlide].classList.add('--active')
        activeThumb(this.currentSlide)
    }

    // Update active thumbnail
    function activeThumb(slide) {
        thumbnails.forEach(item => item.classList.remove('--active'))
        thumbnails[slide].classList.add('--active')
    }
})
